/* eslint-disable no-console, no-underscore-dangle */
import { gaAddToCart } from './ga-ecommerce-utils';
import { getCookie, setCookie } from './cookie-utils';

const addToOrderLine = (itemNo, group, unitPrice, itemQty) => (
  new Promise((resolve, reject) => {
    const _group = !group ? '' : group;
    const _unitPrice = !unitPrice ? '' : unitPrice;
    const _itemQty = !itemQty ? '1' : itemQty;
    fetch(`${window.location.protocol}//${window.location.hostname}/RouteOrderLine?itemNo=${itemNo}&group=${_group}&unitPrice=${_unitPrice}&itemQty=${_itemQty}`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((r) => {
        gaAddToCart(itemNo)
          .then(() => {
            if (r.ok) {
              r.json().then(resolve);
            } else {
              r.json().then(reject);
            }
          });
      })
      .catch(console.error);
  })
);

const removeOrderLine = itemNo => (
  new Promise((resolve, reject) => {
    fetch(`${window.location.protocol}//${window.location.hostname}/RemoveOrderLine?itemNo=${itemNo}`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((r) => {
        if (r.ok) {
          r.json().then(resolve);
        } else {
          r.json().then(reject);
        }
      })
      .catch(console.error);
  })
);

const addOutdoorProductToOrderLine = (itemNo, group) => (
  new Promise((resolve, reject) => {
    fetch(`${window.location.protocol}//${window.location.hostname}/RouteOrderLine?itemNo=${itemNo}&group=${group}`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((r) => {
        gaAddToCart(itemNo, group)
          .then(() => {
            if (r.ok) {
              r.json().then(resolve);
            } else {
              r.json().then(reject);
            }
          });
      })
      .catch(console.error);
  })
);

const captureScreenDimensions = () => {
  const { navigator, screen } = window;
  const { height, width } = screen;
  const { userAgent } = navigator;
  const COOKIE_NAME = 'sst-ss';
  // Only run if cookie has w/ dimensions has not been set
  if (getCookie(COOKIE_NAME) === '') {
    const screenDims = `${height}x${width}`;
    const url = `${window.location.protocol}//${window.location.hostname}/api/SaveScreenSize/?ss=${screenDims}&ua=${userAgent.replace(/\s/g, '')}`;
    fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          // Only storing the screen dimensions in the cookie
          setCookie(COOKIE_NAME, screenDims, 200);
        }
      })
      .catch(console.error);
  }
};

export {
  addOutdoorProductToOrderLine,
  addToOrderLine,
  captureScreenDimensions,
  removeOrderLine,
};
/* eslint-enable no-console, no-underscore-dangle */
